module.exports = __webpack_public_path__ + "static/media/uj_szerzkot3.fa35b3e9.jpg";